import { supabase } from "@/lib/supabase";

export interface StaffApiResult<T = unknown> {
  ok: boolean;
  data?: T;
  error?: string;
}

async function readErrorMessage(error: unknown): Promise<string> {
  const fallback = "请求失败，请稍后重试";
  if (!error) return fallback;
  const ctx = (error as { context?: Response }).context;
  if (ctx && typeof ctx.json === "function") {
    try {
      const body = await ctx.json();
      if (body?.error) return String(body.error);
      if (body?.message) return String(body.message);
    } catch {
      /* ignore parse error */
    }
  }
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}

export async function callStaffApi<T = unknown>(
  payload: Record<string, unknown>,
): Promise<StaffApiResult<T>> {
  try {
    const { data, error } = await supabase.functions.invoke("admin-staff", {
      body: payload,
    });
    if (error) {
      return { ok: false, error: await readErrorMessage(error) };
    }
    if (data && typeof data === "object" && "error" in data && data.error) {
      return { ok: false, error: String((data as { error: unknown }).error) };
    }
    return { ok: true, data: data as T };
  } catch (err) {
    return {
      ok: false,
      error: err instanceof Error ? err.message : "网络异常，请稍后重试",
    };
  }
}